import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { EQUIPMENT_STATE_ALL_LIST_CHART_DEFINITION } from './equipment-state-all-list-chart.definition';
import { EQUIPMENT_STATE_ALL_LIST_CHART_MOCK_DATA } from './equipment-state-all-list-chart.mock';

export const EquipmentStateAllListChart = (props: ListChartProps) => <ListChart {...props} />;

EquipmentStateAllListChart.definition = EQUIPMENT_STATE_ALL_LIST_CHART_DEFINITION;
EquipmentStateAllListChart.mockData = EQUIPMENT_STATE_ALL_LIST_CHART_MOCK_DATA;
